module.exports = __webpack_public_path__ + "img/product_74.c89fc82.svg";